import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '@/lib/api';
import { useSession } from '@/lib/session';
import { ProductGrid, type ProductSummary } from '@/components/product-card';
import { Button, CardSkeleton, EmptyState, Screen, SubHeader } from '@/components/ui';

export default function FavoritesPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authorized } = useSession();

  const favorites = useQuery({
    queryKey: ['favorites'],
    queryFn: async () => (await api.get<ProductSummary[]>('/favorites')).data,
    enabled: authorized,
  });

  if (!authorized) {
    return (
      <>
        <SubHeader title={t('favorites.title')} />
        <Screen>
          <EmptyState title={t('common.outsideTelegram')} />
        </Screen>
      </>
    );
  }

  return (
    <>
      <SubHeader title={t('favorites.title')} />
      <Screen>
        {favorites.isLoading ? (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
            {[0, 1].map((i) => (
              <CardSkeleton key={i} />
            ))}
          </div>
        ) : !favorites.data || favorites.data.length === 0 ? (
          <EmptyState
            title={t('favorites.empty')}
            hint={t('favorites.hint')}
            action={
              <Button variant="secondary" size="sm" onClick={() => navigate('/categories')}>
                {t('cart.goToCatalog')}
              </Button>
            }
          />
        ) : (
          <ProductGrid
            products={favorites.data}
            favorites={new Set(favorites.data.map((p) => p.id))}
          />
        )}
      </Screen>
    </>
  );
}
